const API_CONSTANT = {
  ENDPOINTS: {
    IHOME: process.env.REACT_APP_IHOME_BACKEND_ENDPOINT,
  },
  METHOD: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
  },
  PATH: {
    USER: {
      INFO: "/ihome/app/v1/user",
      UPDATE: "/ihome/app/v1/user",
      ADD_ASSET: "/ihome/app/v1/user/asset/add",
      REMOVE_ASSET: "/ihome/app/v1/user/asset/remove",
      NOTIFICATION: "/ihome/app/v1/user/notification",
      ONBOARD: "/ihome/app/v1/user/onboarding",
      MY_ONBOARD_REQUEST: "/ihome/app/v1/user/onboarding-request/mine",
      MAINTENANCE: "/ihome/app/v1/user/maintenance",
      MAINTENANCE_HOME_SUMMARY: "/ihome/app/v1/user/maintenance/home-summary",
      MAINTENANCE_RECORDS: "/ihome/app/v1/user/maintenance/records",
      MAINTENANCE_PAYMENT_PROOF_BASE: "/ihome/app/v1/user/maintenance/records",
      FEED: "/ihome/app/v1/user/feed",
      VEHICLE_PARKING: "/ihome/app/v1/user/vehicle-parking",
      MY_VEHICLES: "/ihome/app/v1/user/asset/vehicles",
      VEHICLE_LIMIT_STATUS: "/ihome/app/v1/user/asset/vehicle-limit-status",
      FUND_STATEMENT: "/ihome/app/v1/user/fund/statement",
      FUND_STATEMENT_RANGE: "/ihome/app/v1/user/fund/statement/range",
      LOOKUP_BY_UID: "/ihome/app/v1/user/lookup-by-uid",
      IMAGE_PROXY: "/ihome/app/v1/user/image-proxy",
    },
    WALLET: {
      STATEMENT: "/ihome/app/v1/user/wallet/statement",
      ADD_MONEY: "/ihome/app/v1/user/wallet/add",
    },
    AUTH: {
      MEMBERSHIPS: "/ihome/app/v1/auth/memberships",
      SWITCH_MEMBERSHIP: "/ihome/app/v1/auth/switch-membership",
    },
    SOCIETY: {
      GALLERY: "/ihome/app/v1/society/gallery",
      NOTICE_BOARD: "/ihome/app/v1/society/noticeBoard",
      GET_DOCS: "/ihome/app/v1/society/getDocs",
      UPLOAD_DOCS: "/ihome/app/v1/society/uploadDoc",
      DELETE_DOCS: "/ihome/app/v1/society/DeleteDoc",
      DOC_FILE: (docId: number) => `/ihome/app/v1/society/doc/${docId}/file`,
      INFO: "/ihome/app/v1/society/detail",
      MEMBERS: "/ihome/app/v1/society/allMembers",
      WING_LIST: "/ihome/app/v1/society/wing",
      WING_PARKING_ZONES: "/ihome/app/v1/society/wing", // append /{wingId}/parking-zones
      HOME_LIST: "/ihome/app/v1/society/home",
      ANNOUCEMENT: "/ihome/app/v1/society/announcement",
      EN_NUMBERS: "/ihome/app/v1/society/emergencyNumber",
      GUARD: "/ihome/app/v1/society/guard",
      GUARD_MY_PROFILE: "/ihome/app/v1/society/guard/profile",
      LIST: "/ihome/app/v1/society",
      BUILDING: "/ihome/app/v1/society/building",
      REGISTER: "/ihome/app/v1/society/registerSociety",
      ASSIGN_ADMIN: "/ihome/app/v1/society/assignAdmin",
      CONFIG: "/ihome/app/v1/society/config",
      PETS: '/ihome/app/v1/society/pets',
      COMMITTEE: '/ihome/app/v1/society/committee',
    },
    MEMBER_REQUEST: {
      ONBOARD_REQ: "/ihome/app/v1/user/onboarding-request",
      HANDLE: "/ihome/app/v1/admin/member-request",
      STATS: "/ihome/app/v1/admin/member-stats",
      VEHICLE_STATS: "/ihome/app/v1/admin/vehicle-stats",
    },
    DAILY_HELP: {
      GET: "/ihome/app/v1/daily-help",
      MY_PROFILE: "/ihome/app/v1/daily-help/profile",
      CATEGORIES: "/ihome/app/v1/daily-help/categories",
      LINKED_TO_HOME: "/ihome/app/v1/daily-help/linked-to-home",
      PROFILE: (id: number) => `/ihome/app/v1/daily-help/${id}`,
      LINK_HOME: (id: number) => `/ihome/app/v1/daily-help/${id}/link-home`,
      UNLINK_HOME: (id: number) => `/ihome/app/v1/daily-help/${id}/unlink-home`,
      REVIEWS: (id: number) => `/ihome/app/v1/daily-help/${id}/reviews`,
      ATTENDANCE: (id: number) => `/ihome/app/v1/daily-help/${id}/attendance`,
      EXIT: (id: number) => `/ihome/app/v1/daily-help/${id}/exit`,
    },
    PET: {
      UPDATE_PHOTO: "/ihome/app/v1/user/asset/pet/photo",
    },
    ADDRESS: {
      ADD: "/ihome/app/v1/user/address",
      UPDATE: "/ihome/app/v1/user/address",
      DELETE: "/ihome/app/v1/user/address",
      GET: "/ihome/app/v1/user/address",
    },
    VISITOR: {
      ADD: "/ihome/app/v1/user/visitor",
      DELETE: "/ihome/app/v1/user/visitor",
      GET: "/ihome/app/v1/user/visitor",
      UPDATE: "/ihome/app/v1/user/visitor",
      LOOKUP: "/ihome/app/v1/user/visitor/lookup",
      SCAN: "/ihome/app/v1/user/visitor/scan",
      APPROVE: "/ihome/app/v1/user/visitor/approve",
      RECENT: "/ihome/app/v1/user/visitor/recent",
      STATS: "/ihome/app/v1/user/visitor/stats",
    },
    COMPLAINT: {
      ADD: "/ihome/app/v1/society/complaint",
      GET: "/ihome/app/v1/society/complaint",
      UPDATE: "/ihome/app/v1/society/complaint",
      ADD_REACTION: "/ihome/app/v1/society/complaint/reaction",
      STATS: "/ihome/app/v1/society/complaint/stats",
    },
    SOS: {
      RAISE: "/ihome/app/v1/society/sos",
      ACTIVE: "/ihome/app/v1/society/sos/active",
      HISTORY: "/ihome/app/v1/society/sos/history",
      MINE: "/ihome/app/v1/society/sos/mine",
      CATEGORY: (id: number) => `/ihome/app/v1/society/sos/${id}/category`,
      CANCEL: (id: number) => `/ihome/app/v1/society/sos/${id}/cancel`,
      ACKNOWLEDGE: (id: number) => `/ihome/app/v1/society/sos/${id}/acknowledge`,
      RESOLVE: (id: number) => `/ihome/app/v1/society/sos/${id}/resolve`,
    },
    FUNCTION: {
      ADD: "/ihome/app/v1/society/function",
      GET: "/ihome/app/v1/society/function",
      UPDATE: "/ihome/app/v1/society/function",
      DELETE: "/ihome/app/v1/society/function",
      SUBMIT_ATTENDEE: "/ihome/app/v1/society/function/participant",
      RSVP: "/ihome/app/v1/society/function/rsvp",
      PARTICIPANTS: "/ihome/app/v1/society/function/participants",
      STATUS_CHANGE: "/ihome/app/v1/society/function/status",
    },
    MAINTENANCE: {
      GET: "/ihome/app/v1/society/maintenance",
      STATS: "/ihome/app/v1/society/maintenance/stats",
      RECORDS: "/ihome/app/v1/society/maintenance/records",
      CREATE_CYCLE: "/ihome/app/v1/society/maintenance/cycle",
      UPDATE_CYCLE: "/ihome/app/v1/society/maintenance/cycle",
      DELETE_CYCLE: "/ihome/app/v1/society/maintenance/cycle",
      MARK_PAID: "/ihome/app/v1/society/maintenance/mark-paid",
      MARK_UNPAID: "/ihome/app/v1/society/maintenance/mark-unpaid",
      SEND_REMINDER: "/ihome/app/v1/society/maintenance/send-reminder",
      VERIFICATION_QUEUE: "/ihome/app/v1/society/maintenance/verification-queue",
      VERIFY_PAYMENT: "/ihome/app/v1/society/maintenance/verify-payment",
      BANK_STATEMENT_UPLOAD: "/ihome/app/v1/society/maintenance/bank-statement",
      BANK_STATEMENT_LIST: "/ihome/app/v1/society/maintenance/bank-statement",
      BANK_STATEMENT_STATUS: (id: number | string) => `/ihome/app/v1/society/maintenance/bank-statement/${id}`,
      BANK_STATEMENT_TRANSACTIONS: (id: number | string) => `/ihome/app/v1/society/maintenance/bank-statement/${id}/transactions`,
      BANK_STATEMENT_FILE: (id: number | string) => `/ihome/app/v1/society/maintenance/bank-statement/${id}/file`,
      RECORD_RECEIPTS: (recordId: number | string) => `/ihome/app/v1/society/maintenance/records/${recordId}/receipts`,
      RECEIPT_FILE: (receiptId: number | string) => `/ihome/app/v1/society/maintenance/receipt/${receiptId}`,
      BANK_STATEMENT_CHECKER_QUEUE: "/ihome/app/v1/society/maintenance/bank-statement/checker-queue",
      BANK_STATEMENT_VERIFY_PAYMENT: "/ihome/app/v1/society/maintenance/bank-statement/verify-payment",
      BANK_STATEMENT_APPLY: (txnId: number | string) => `/ihome/app/v1/society/maintenance/bank-statement/transaction/${txnId}/apply`,
      EXTRA_CHARGE: {
        CREATE: "/ihome/app/v1/society/maintenance/extra-charge",
        GET: "/ihome/app/v1/society/maintenance/extra-charge",
        DELETE: "/ihome/app/v1/society/maintenance/extra-charge",
      },
    },
    VEHICLE_PARKING: {
      GET: "/ihome/app/v1/society/vehicle-parking",
      SHUFFLE: "/ihome/app/v1/society/vehicle-parking/shuffle",
      SWAP: "/ihome/app/v1/society/vehicle-parking/swap",
      UPDATE: "/ihome/app/v1/society/vehicle-parking/update",
    },
    FUND: {
      STATEMENT: "/ihome/app/v1/society/fund/statement",
      STATEMENT_RANGE: "/ihome/app/v1/society/fund/statement/range",
      ADD_EXPENSE: "/ihome/app/v1/society/fund/expense",
      DELETE_EXPENSE: "/ihome/app/v1/society/fund/expense",
      LEDGER_RECEIPT: "/ihome/app/v1/society/fund/ledger/receipt",
      EXPENSE_RECEIPT: "/ihome/app/v1/society/fund/expense/receipt",
      MANUAL_ENTRY: "/ihome/app/v1/society/fund/manual-entry",
      SET_OPENING_BALANCE: "/ihome/app/v1/society/fund/opening-balance",
      WING_BALANCES: "/ihome/app/v1/society/fund/wing-balances",
      MODE: "/ihome/app/v1/society/fund/mode",
    },
    POLLING: {
      GET: "/ihome/app/v1/society/polling",
      POST: "/ihome/app/v1/society/polling",
      POST_VOTE: "/ihome/app/v1/society/polling/vote",
      FINALIZE: "/ihome/app/v1/society/polling/finalize",
    },
    ELECTION: {
      GET: "/ihome/app/v1/society/election",
      POST: "/ihome/app/v1/society/election",
      POST_VOTE: "/ihome/app/v1/society/election/vote",
      POST_NOMINATION: "/ihome/app/v1/society/election/nomination",
      POST_APPROVE_NOMINATION: "/ihome/app/v1/society/election/nomination/approve",
      POST_REJECT_NOMINATION: "/ihome/app/v1/society/election/nomination/reject",
      POST_START: "/ihome/app/v1/society/election",
      PARTICIPATION: (electionId: number) => `/ihome/app/v1/society/election/${electionId}/participation`,
    },
    PRODUCT: {
      GET: "/ihome/app/v1/user/product",
    },
    AGENT: {
      SOCIETIES: "/ihome/app/v1/agent/societies",
      DEMOTE_ADMIN: (societyId: number, userId: number) => `/ihome/app/v1/agent/societies/${societyId}/admin/${userId}`,
      CHANGE_ADMIN_SCOPE: (societyId: number, userId: number) => `/ihome/app/v1/agent/societies/${societyId}/admin/${userId}/scope`,
      SOCIETY_SUBSCRIPTION: (societyId: number) => `/ihome/app/v1/agent/societies/${societyId}/subscription`,
      FUND_MODE: (societyId: number) => `/ihome/app/v1/agent/societies/${societyId}/fund-mode`,
    },
    SUBSCRIPTION: {
      GET: "/ihome/app/v1/subscription",
      PLANS: "/ihome/app/v1/subscription/plans",
      STATUS: "/ihome/app/v1/subscription/status",
    },
    UTILS: {
      PINCODE: "/ihome/app/v1/utils/pincode",
    },
  },
  PARAMS: {
    USER: {
      INFO: {
        FULL_PROFILE: "fullProfile"
      }
    }
  },
};

export default API_CONSTANT;
